import { useState } from "react";
import isEmpty from "../../../validation/is-empty";
import One from "../../../assets/bookingeventassets/assets/1.svg";
import ArrowLeft from "../../../assets/icons/arrow-left.svg";
import Loader from "../../../components/Loader/Loader";
import { getUserBrowserTimezone } from "../../../utils/utility";

const PaymentCancelledConfirmation = ({ 
    event = {}, 
    bookingData = {},
    specialRibbon = ''
}) => {

    const [isLoading, setIsLoading] = useState(false);

    return (
        <>
          <Loader isShowLoader={isLoading} />
          <div className="row">
            {!isEmpty(specialRibbon) && (
              <div className="col-12">
                <nav className="navbar navbar-expand-sm main_noti shadow">
                  <ul className="navbar-nav">
                    <li className="nav-item noti_side">
                      <img src={One} alt="Notification" />
                    </li>
                    <li className="nav-item left_noti ml-3 ml-md-0">
                      <span>{specialRibbon}</span>
                    </li>
                  </ul>
                </nav>
              </div>
            )}
            <div className="col-12">
              <div className="booking_arrow row align-items-center mx-0">
                <div className="col-auto">
                  <img src={ArrowLeft} alt="Arrow Left" />
                </div>
                <div className="col-auto ps-0">
                  <p>Back</p>
                </div>
                <h1>Booking Cancelled</h1>
              </div>
            </div>
          </div>

          <div className="row justify-content-center sub_div payment-cancelled-confirmation">
            <div className="col-12 col-md-10 col-lg-8">
              {/* Confirmation Header */}
              <div className="main_add border-0 confirmation-header">
                {/* Background Circles */}
                <div className="background-circles"></div>
                <div className="background-circles"></div>
                
                <div className="confirmation-content">
                  <div className="confirmation-icon">
                    <i className="fas fa-times-circle"></i>
                  </div>
                  <h2 className="mb-3">Payment Cancelled Successfully</h2>
                  <p className="mb-0">
                    Your payment has been cancelled and no charges have been made to your account.
                  </p>
                </div>
              </div>

              {/* Booking Details Card */}
              <div className="main_add border-0 booking-details-card">
                <h4 className="mb-4">
                  <i className="fas fa-calendar-times me-3"></i>
                  Cancelled Booking Details
                </h4>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <div className="booking-detail-item">
                      <label className="form-group-label text-muted mb-2">Event</label>
                      <p className="mb-0 fw-bold text-truncate" title={event.event_name || '[Event name]'}>
                        {event.event_name || '[Event name]'}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="booking-detail-item">
                      <label className="form-group-label text-muted mb-2">Date & Time</label>
                      <p className="mb-0 text-truncate" title={bookingData.bookingDate || '[Booking Date]'}>
                        {bookingData.bookingDate || '[Booking Date]'}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="booking-detail-item">
                      <label className="form-group-label text-muted mb-2">Attendee</label>
                      <p className="mb-0 text-truncate" title={bookingData.firstName || '[First Name]'}>
                        {bookingData.firstName || '[First Name]'}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="booking-detail-item">
                      <label className="form-group-label text-muted mb-2">Email</label>
                      <p className="mb-0 text-truncate" title={bookingData.email || '[Email]'}>
                        {bookingData.email || '[Email]'}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="booking-detail-item">
                      <label className="form-group-label text-muted mb-2">Timezone</label>
                      <p className="mb-0 text-truncate" title={bookingData.timezoneValue || getUserBrowserTimezone()}>
                        {bookingData.timezoneValue || getUserBrowserTimezone()}
                      </p>
                    </div>
                  </div>
                  <div className="col-12 mb-3">
                    <div className="booking-detail-item">
                      <label className="form-group-label text-muted mb-2">Message</label>
                      <p className="mb-0 text-break" title={bookingData.messageFromCustomer || '[Message from Customer]'}>
                        {bookingData.messageFromCustomer || '[Message from Customer]'}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Important Information */}
              <div className="main_add border-0 important-info">
                <div className="info-content">
                  <i className="fas fa-info-circle me-3"></i>
                  <div>
                    <h5 className="mb-2">Important Information</h5>
                    <ul className="mb-0">
                      <li>Your booking slot has been released and is now available for others</li>
                      <li>No payment has been processed to your account</li>
                      <li>You can book this event again if the slot is still available</li>
                      <li>If you have any questions, please contact our support team</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="main_add border-0 action-buttons">
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <button className="btn rd_cancel btn-lg w-100">
                      <i className="fas fa-calendar-plus me-2"></i>
                      Book Again
                    </button>
                  </div>
                  <div className="col-md-6 mb-3">
                    <button className="btn btn-app btn-lg w-100">
                      <i className="fas fa-home me-2"></i>
                      Go to Company Page
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      );
    
}

export default PaymentCancelledConfirmation;
